import { Grid, Typography } from '@mui/material';

import { GamePreview } from '@occc-app/routes/Game/GameConfigureForm/components/GamePreview';
import {
  GameType,
  SegmentFormValues,
  SpinWheelGameOfferFormValues,
} from '@occc-app/routes/Game/types';

import { Box } from '@occc-app/design-system';
import { Card, Divider, InfoField, Link } from '@occc/ui-design-system';

import { Fragment } from 'react';
import { GameSegment } from './game-segment.component';
import { SectionCard } from '../../components';
import { BREAK_URLS_STYLE } from '../constants';

type GameSectionProps = {
  gameType: GameType;
  gameConfig: SpinWheelGameOfferFormValues | null;
  segments: SegmentFormValues[];
  isGameplayAmountDisplayed?: boolean;
};

export const GameSection = ({
  gameConfig,
  segments,
  gameType,
  isGameplayAmountDisplayed = false,
}: GameSectionProps) => {
  const { backgroundImage, foregroundImage } = gameConfig || {};

  return (
    <SectionCard title='Segments'>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={8} md={6}>
          {segments.map((segment, index) => (
            <Fragment key={segment.id}>
              <GameSegment index={index} segment={segment} />
              <Divider sx={{ my: 2 }} />
            </Fragment>
          ))}
          <Typography variant='subtitle1' sx={{ mb: 3 }} gutterBottom>
            Images
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <InfoField
                label='Background Image URL'
                value={
                  backgroundImage ? (
                    <Link
                      href={backgroundImage}
                      target='_blank'
                      rel='noopener noreferrer'
                      sx={BREAK_URLS_STYLE}
                    >
                      {backgroundImage}
                    </Link>
                  ) : undefined
                }
                disableTypography={!!backgroundImage}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InfoField
                label='Foreground Image URL'
                value={
                  foregroundImage ? (
                    <Link
                      href={foregroundImage}
                      target='_blank'
                      rel='noopener noreferrer'
                      sx={BREAK_URLS_STYLE}
                    >
                      {foregroundImage}
                    </Link>
                  ) : undefined
                }
                disableTypography={!!foregroundImage}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} lg={4} md={6}>
          <Box display='flex' justifyContent={{ xs: 'center', md: 'flex-start' }}>
            <Card variant='outlined' elevation={0}>
              <GamePreview
                gameType={gameType}
                segments={segments}
                spinWheelGameConfig={gameConfig}
                isGameplayAmountDisplayed={isGameplayAmountDisplayed}
                cssWidth='340px'
                cssHeight='700px'
              />
            </Card>
          </Box>
        </Grid>
      </Grid>
    </SectionCard>
  );
};
